exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".service-checklist-style-section .hr-line {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important; }\n\n.service-checklist-style-section .text-input-section {\n  width: 90px !important;\n  margin-left: 10px;\n  margin-right: 10px; }\n\n.service-checklist-style-section .sort-order-input {\n  width: 50px !important; }\n\n.service-checklist-style-section .remove-right-margin {\n  margin-right: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/service_settings/service-checklist/service_checklists.scss
// module id = 1087
// module chunks = 1